import { render, staticRenderFns } from "./housing_units.vue?vue&type=template&id=bc9910f0&scoped=true"
import script from "./housing_units.vue?vue&type=script&lang=js"
export * from "./housing_units.vue?vue&type=script&lang=js"
import style0 from "./housing_units.vue?vue&type=style&index=0&id=bc9910f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9910f0",
  null
  
)

export default component.exports